<template>
  <div class="px-8 pt-3 pb-5 md:px-24">
    <settings-header
      active-tab="accounts"
      :entity-id="entityId"
    />
    <div
      v-if="noAccounts"
      class="flex flex-col items-center pt-16"
    >
      <div class="text-left">
        <img
          :src="require('@assets/images/wallet-empty.svg')"
          class="p-3 rounded shadow-sc-icon"
        >
        <p
          class="pt-4 text-xl leading-7 text-primary"
        >
          {{ $t('message.settings.accountsTab.connectAccounts') }}
        </p>
        <p
          class="w-56 pt-2 text-secondary"
        >
          {{ $t('message.settings.accountsTab.noAccountsMessage') }}
          {{ $t('message.settings.accountsTab.looklikeMessage') }}
        </p>
        <button
          class="inline-block px-3 py-1 mt-5 text-sm leading-5 text-center text-white rounded bg-sc-blue"
          @click="toggleLinkModal"
        >
          {{ $t('message.settings.accountsTab.connectAccount') }}
        </button>
      </div>
    </div>
    <div v-else>
      <div class="flex flex-col-reverse justify-between gap-8 mt-5 md:flex-row md:mt-10">
        <h1
          class="text-xl text-left text-sc-gray-dark"
        >
          {{ $t('message.settings.accountsTab.availableBalances') }}
        </h1>
        <button
          class="inline-block px-3 py-1 text-sm leading-5 text-center text-white rounded bg-sc-blue hover:text-white"
          @click="toggleLinkModal"
        >
          {{ $t('message.settings.accountsTab.connectAccount') }}
        </button>
      </div>

      <div class="flex flex-col flex-wrap items-center md:flex-row">
        <balance
          v-for="curr in activeCurrencies()"
          :key="curr"
          :currency="curr"
          :active-bank-accounts="activeAccountsInCurrency(curr)"
        />
      </div>
      <h1
        class="mt-10 text-xl text-left text-sc-gray-dark"
      >
        {{ $t('message.settings.accountsTab.accounts') }}
      </h1>
      <div class="flex flex-col flex-wrap items-center md:flex-row md:items-stretch">
        <div
          class="w-full mt-5 md:mr-6 md:w-auto"
          v-for="(account, index) in accounts"
          :key="index"
          :ref="`account-${index}`"
        >
          <account
            :account="account"
            :entity-id="entityId"
            :active-accounts="activeAccounts"
            @edit="updateActiveAccounts"
          />
        </div>
        <div
          class="w-full mt-5 mb-10 md:mb-0 md:mr-5 md:w-auto"
        >
          <button
            class="w-full h-full md:w-auto"
            ref="connect-account-card"
            @click="toggleLinkModal"
          >
            <div
              class="flex flex-col items-center justify-center h-full py-3 border-2 border-dashed rounded-lg md:w-56"
            >
              <div class="flex items-center justify-center w-10 h-10 text-center rounded shadow-sc-button border-sc-gray-light">
                <img
                  class="w-4 opacity-50"
                  :src="require('@assets/images/plus.svg')"
                >
              </div>
              <p
                class="mt-3 text-sm text-secondary"
              >
                {{ $t('message.settings.accountsTab.connectAccount') }}
              </p>
            </div>
          </button>
        </div>
      </div>
    </div>
    <add-link-modal
      ref="linkModal"
      :entity-id="entityId"
      :can-connect-accounts="ableToConnectAccounts()"
      @onSuccess="redirectToBankMovements()"
    />
    <gifs-modal
      ref="gifsModal"
      v-if="noAccounts && !isMobile"
      @connect="toggleLinkModal()"
    />
  </div>
</template>

<script>
import Account from './account.vue';
import AddLinkModal from '../add-link-modal.vue';
import GifsModal from '../gifs-modal.vue';
import SettingsHeader from '../settings-header.vue';
import Balance from './balance.vue';
import isMobile from '../../utils/isMobile.js';

export default {
  beforeMount() {
    this.$store.dispatch('setEntityId', this.entityId);
    this.$store.dispatch('getEntityConfiguration');
    this.$store.dispatch('getBankAccounts');
    this.$store.dispatch('getAccounts');
  },
  components: {
    Account,
    AddLinkModal,
    GifsModal,
    SettingsHeader,
    Balance,
  },
  props: {
    entityId: {
      type: Number,
      required: true,
    },
    accounts: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      activeAccounts: this.accounts.reduce((acc, currentAccount) => acc + (currentAccount.isActive ? 1 : 0), 0),
      noAccounts: this.accounts.length === 0,
      isMobile: isMobile(),
    };
  },
  created() {
    if (this.noAccounts) {
      const showGifsTimer = 2000;
      setTimeout(() => {
        this.toggleGifsModal();
      },
      showGifsTimer);
    }
  },
  computed: {
    activeBankAccounts() {
      return this.$store.getters.activeBankAccounts;
    },
  },
  methods: {
    updateActiveAccounts(isActive) {
      this.activeAccounts += isActive ? 1 : -1;
    },
    toggleLinkModal() {
      this.$refs.linkModal.show();
    },
    toggleGifsModal() {
      this.$refs.gifsModal.show();
    },
    ableToConnectAccounts() {
      return !this.accounts.length > 0 || this.$store.getters.isClient;
    },
    activeAccountsInCurrency(currency) {
      return this.activeBankAccounts.filter(account => account.currency === currency);
    },
    activeCurrencies() {
      return ['CLP', 'USD', 'EUR'].filter(currency => this.activeAccountsInCurrency(currency).length > 0);
    },
    balanceForCurrency(currency) {
      return this.activeAccountsInCurrency(currency).reduce((acc, account) => (acc + account.currentBalance), 0);
    },
    redirectToBankMovements() {
      window.location = `/entities/${this.entityId}/bank_movements`;
    },
  },
};
</script>
